import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, timeout } from 'rxjs';
import { ConstantSetterAndGetterService } from '../app.constants';
import { environment } from 'src/app/environments/environments';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class AumyeAuthenticationService {
  constructor(
    private httpClient: HttpClient,
    private constantSetterAndGetterService: ConstantSetterAndGetterService
  ) {}
  baseServerURL = environment.apiUrl;

  onLogin(params: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Platform: Capacitor.getPlatform(),
      }),
    };
    return this.httpClient
      .post(this.baseServerURL + 'Login', params, {
        headers: httpOptions.headers,
      })
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  onOtpLogin(params: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Platform: Capacitor.getPlatform(),
      }),
    };
    return this.httpClient
      .post(this.baseServerURL + 'OTPLogin', params, {
        headers: httpOptions.headers,
      })
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  onSelectedOrgLogin(params: any): Observable<any> {
    return this.httpClient
      .post(this.baseServerURL + 'SelectedOrgLogin', params)
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  onSendOTP(params: any): Observable<any> {
    return this.httpClient
      .post(this.baseServerURL + 'SendOTP', params, { responseType: 'text' })
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  onSendLoginOTP(params: any): Observable<any> {
    return this.httpClient
      .post(this.baseServerURL + 'SendLoginOTP', params, {
        responseType: 'text',
      })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  GetAllOrganization(data?: string): Observable<any> {
    return this.httpClient
      .get(this.baseServerURL + 'GetAllOrganization', {
        params: { data },
      })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  CheckValidLogin(params: any): Observable<any> {
    return this.httpClient
      .post(this.baseServerURL + 'VerifyUserExists', params, {
        responseType: 'text',
      })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }
  onRegisterOrganization(params: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        CurrentUrl: window.location.href,
      }),
    };
    return this.httpClient
      .post(this.baseServerURL + 'AddNewOrganization', params, {
        responseType: 'text',
        headers: httpOptions.headers,
      })
      .pipe(
        timeout(
          this.constantSetterAndGetterService.getConstants().POSTCALL_TIMEOUT
        ),
        map((response: any) => {
          return response;
        }),
        catchError((err: Error): any => {
          return this.serializeError(err);
        })
      );
  }

  private serializeError(err: any) {
    const status = err.status;
    if (status == 500) {
      throw {
        global: "That's an error. Try again",
        status,
      };
    }
    if (status == 401 || status == 400 || status == 404) {
      const responseObject: any = err.body || err.error;
      if (responseObject) {
        throw {
          global: responseObject,
          status,
        };
      }
    }
    if (!status && status !== 0 && err.name === 'TimeoutError') {
      throw {
        global: 'It took longer than expected. Please try again.',
        status,
      };
    }
    if (!status && status === 0 && err?.name === 'HttpErrorResponse') {
      throw {
        global: navigator?.onLine
          ? 'Error while connecting to server.'
          : 'Please check your internet connection and try again.' +
            'InternetError',
        status,
      };
    }
    throw {
      global: "That's an error. Try again",
      status,
    };
  }
  private serializeResponse(response: any) {
    if (response.status == 200) {
    }
    return response;
  }
}
